import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AuthModal from '../components/AuthModal';

const LoginPage = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // If user is already authenticated, redirect to home
    if (isAuthenticated) {
      navigate('/');
      return;
    }

    // Open the modal automatically when the page loads
    const timer = setTimeout(() => {
      setIsModalOpen(true);
    }, 100);

    return () => clearTimeout(timer);
  }, [isAuthenticated, navigate]);

  const handleClose = () => {
    setIsModalOpen(false);
    // Redirect to home after closing modal
    setTimeout(() => {
      navigate('/');
    }, 300);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <AuthModal
        isOpen={isModalOpen}
        onClose={handleClose}
        initialMode="login"
      />
    </div>
  );
};

export default LoginPage;
